import { BEXHeader } from './template-bex';
import { TemplateA } from './template-a';
import { TemplateB } from './template-b';
import { TemplateC } from './template-c';
import { TemplateBlank } from './template-blank';
import { TemplateId } from '../../../../types/common';
export var templateMap = new Map([[TemplateId.BEXHeader.valueOf(), BEXHeader], [TemplateId.TemplateA.valueOf(), TemplateA], [TemplateId.TemplateB.valueOf(), TemplateB], [TemplateId.TemplateC.valueOf(), TemplateC], [TemplateId.TemplateBlank.valueOf(), TemplateBlank]]);
export function getHeaderComponent(globalComponentsContext) {
  var template = globalComponentsContext && globalComponentsContext.header && globalComponentsContext.header.templateId || TemplateId.BEXHeader.valueOf();
  return templateMap.get(template);
}